export enum FeatureToggle {
  pageBuilderSingleRetailer = 'rt_pagebuilder_single_retailer',
  brandingV2 = 'rt_ipp_branding_v2',
  collectionSelectorAdvanced = 'rt_collection_selector_advanced',
  creativeManagerV2 = 'rt_creative_manager_v2',
}
